module.exports = __webpack_public_path__ + "static/07acdb99dda16fd671ab14b06715d9a5369d48a41a8e7cc8042a3a7f9e803ad3-b7a1e0583221f465f6f59db2a6875f06.png";